import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import moment from 'moment';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from '../../../../../deviceFullInfoState/deviceFullInfoContext';

const CreatedField: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	const inputValue = deviceForFullInfo?.insertedDate
		? `${moment(deviceForFullInfo.insertedDate).format('MM/DD/YYYY h:mm:ss A')}      ${
				deviceForFullInfo.insertedBy
		  }`
		: undefined;

	return <FullInfoField label="createdLabel" value={inputValue} />;
};

export default CreatedField;
